// extracted by mini-css-extract-plugin
export default {"scroll_x_container":"COhDeyDbQz9weVEmUZDs"};